import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import { DeviceAnalytics, LatestReading } from 'store/reducers/adminReducers';

interface TableProps {
  rows?: DeviceAnalytics[];
}

const formatTimestamp = (timestamp: string | null) =>
  timestamp ? new Date(timestamp).toLocaleString() : '-';

const LocationCell = ({ location }: { location: DeviceAnalytics['location'] }) => (
  <TableCell>
    {location && (location.latitude != null || location.longitude != null) ? (
      <>
        Lat: {location.latitude ?? '-'}
        <br />
        Lon: {location.longitude ?? '-'}
      </>
    ) : (
      '-'
    )}
  </TableCell>
);

const ReadingCell = ({ reading }: { reading: LatestReading | null }) => (
  <TableCell>
    {reading ? (
      <Tooltip title={formatTimestamp(reading.timestamp)}>
        <span>{reading.value}</span>
      </Tooltip>
    ) : (
      '-'
    )}
  </TableCell>
);

function DeviceAnalyticsTable({ rows = [] }: TableProps): React.JSX.Element {
  return (
    <Card>
      <Box sx={{ overflowX: 'auto' }}>
        <Table sx={{ minWidth: '800px' }}>
          <TableHead>
            <TableRow>
              <TableCell>SN</TableCell>
              <TableCell>Device Key</TableCell>
              <TableCell>Organization</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Battery</TableCell>
              <TableCell>Liquid Level</TableCell>
              <TableCell>Signal</TableCell>
              <TableCell>Last Reading</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow hover key={row.device_key}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.device_key}</TableCell>
                <TableCell>{row.organization.name ?? row.organization.id}</TableCell>
                <LocationCell location={row.location} />
                <TableCell>{row.version}</TableCell>
                <ReadingCell reading={row.battery} />
                <ReadingCell reading={row.liquid_level} />
                <ReadingCell reading={row.signal} />
                <TableCell>{formatTimestamp(row.last_reading_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <Divider />
    </Card>
  );
}

export default DeviceAnalyticsTable;
